/**
 * @desc Used for creating the World Selection Scene, where a player decides which planet they want to play on
 */
import BaseScene from './BaseScene';
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { get } from 'svelte/store';
import LoaderStore from '../../shared/LoaderStore';
class SelectionScene extends BaseScene {
    constructor(canvas, updatePlanetName) {
        super(canvas);
        this.canvas = canvas;
        this.updatePlanetName = updatePlanetName;
        this.intersects = [];
        this.updatePlanetName = updatePlanetName;
        this.cursor = new THREE.Vector2(-1, -1);
        this.createSkybox('space', '.jpg');
        this.raycaster = new THREE.Raycaster();
        this.createLavaPlanet(-170);
        this.createRockPlanet(0);
        this.createAlientPlanet(170);
        this.worldCamera.position.set(2, 80, 260);
        const orbitControl = new OrbitControls(this.worldCamera, this.canvas);
        orbitControl.enableZoom = false;
        // Make sure to remove when demounted to prevent memory leaks... should prob pass down from svelte to make sure to unmount properly
        window.addEventListener('mousemove', (event) => {
            this.cursor.x = (event.clientX / window.innerWidth) * 2 - 1;
            this.cursor.y = -(event.clientY / window.innerHeight) * 2 + 1;
        });
        window.addEventListener('click', this.updateClicked.bind(this));
        this.tick();
    }
    createSkybox(path, extension) {
        const cubeLoader = this.loader.getCubeTextureLoader();
        const texture = cubeLoader.load([
            `textures/skybox/${path}/px${extension}`,
            `textures/skybox/${path}/nx${extension}`,
            `textures/skybox/${path}/py${extension}`,
            `textures/skybox/${path}/ny${extension}`,
            `textures/skybox/${path}/pz${extension}`,
            `textures/skybox/${path}/nz${extension}`,
        ]);
        this.scene.background = texture;
    }
    createRockPlanet(x) {
        this.createPlanet(x, get(LoaderStore).loader.getMineralWorldConfig(), 'Morghol');
    }
    createLavaPlanet(x) {
        this.createPlanet(x, get(LoaderStore).loader.getLavaWorldConfig(), 'Velknaz');
    }
    createAlientPlanet(x) {
        this.createPlanet(x, get(LoaderStore).loader.getMultiPlayerWorldConfig(), 'Zetxaru');
    }
    createPlanet(x, materialConfig, name, material) {
        const geometry = new THREE.SphereBufferGeometry(50, 128, 128);
        if (!material)
            material = new THREE.MeshStandardMaterial(materialConfig);
        const planet = new THREE.Mesh(geometry, material);
        planet.geometry.setAttribute('uv2', new THREE.Float32BufferAttribute(planet.geometry.attributes.uv.array, 2));
        planet.name = name;
        planet.position.set(x, 0, -20);
        this.scene.add(planet);
    }
    updateClicked() {
        var _a;
        if (this.intersects.length > 0) {
            this.selectedWorld = (_a = this.intersects[0]) === null || _a === void 0 ? void 0 : _a.object;
            this.updatePlanetName(this.selectedWorld.name);
        }
    }
    getPlanets() {
        return this.scene.children.filter((obj) => obj.name.length > 4);
    }
    tick() {
        requestAnimationFrame(() => {
            const elapsedTime = this.clock.getElapsedTime();
            this.raycaster.setFromCamera(this.cursor, this.worldCamera);
            this.intersects = this.raycaster.intersectObjects(this.getPlanets());
            // Scale planets up when hoovering
            for (const intersect of this.intersects) {
                if (intersect.object.scale.x <= 1.25) {
                    intersect.object.scale.x += 0.015;
                    intersect.object.scale.y += 0.015;
                    intersect.object.scale.z += 0.015;
                }
            }
            // Rotate and let the planets float
            for (const planet of this.getPlanets()) {
                if (!this.intersects.some((obj) => obj.object === planet) &&
                    planet.scale.x > 1 &&
                    planet !== this.selectedWorld) {
                    planet.scale.x -= 0.02;
                    planet.scale.y -= 0.02;
                    planet.scale.z -= 0.02;
                }
                planet.rotation.y -= 0.003;
                planet.position.y = Math.sin(elapsedTime) * 2;
            }
            this.renderer.render(this.scene, this.worldCamera);
            this.tick();
        });
    }
}
export default SelectionScene;
